/* eslint-disable import/newline-after-import */
/* Exports all the actions from a single point.

Allows to import actions like so:

import {action1, action2} from '../actions/'
*/
/* Populated by react-webpack-redux:action */


import * as userActions from './userActions';

import * as cipActions from './cipActions';

import * as fileActions from './fileActions';

import * as initiativeActions from './initiativeActions';


const actions = {...userActions, ...cipActions, ...fileActions, ...initiativeActions};

module.exports = actions;



// WEBPACK FOOTER //
// ./actions/index.js